import {JSX, useEffect, useState} from "react";

export type AmountInputProps = {
    initialValue: number;
    onChange?: (value: number) => void;
    minValue?: number;
    maxValue?: number;
}
export const AmountInput: ({
                               initialValue,
                               onChange,
                               minValue,
                               maxValue
                           }: AmountInputProps) => JSX.Element = ({initialValue, onChange, minValue = 0, maxValue}: AmountInputProps) => {

    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        if (value !== initialValue && typeof onChange === 'function') {
            onChange(value);
        }
    }, [value]);

    const handleMinus = () => {
        setValue(prevValue => Math.max(minValue, prevValue - 1));
    }

    const handlePlus = () => {
        setValue(prevValue => {
            const newValue = prevValue + 1;
            return maxValue !== undefined ? Math.min(maxValue, newValue) : newValue;
        });
    }

    return (
        <div className="amount">
            <button type="button"
                    onClick={handleMinus}
                    className="amount__control amount__control_minus" aria-label="Minus"
                    disabled={value <= minValue}>
                <svg role="img" className="amount__control-ico">
                    <use href="./img/sprite.svg#minus"></use>
                </svg>
            </button>
            <input type="text" className="amount__input" value={value} readOnly disabled/>
            <button type="button"
                    onClick={handlePlus}
                    className="amount__control amount__control_plus" aria-label="Plus"
                    disabled={maxValue !== undefined && value >= maxValue}>
                <svg role="img" className="amount__control-ico">
                    <use href="./img/sprite.svg#plus"></use>
                </svg>
            </button>
        </div>
    );
}
export default AmountInput;